import React from "react";
import PropTypes from "prop-types";
import Icon from "@dtci/spellbook/Icon";
import { getSeverityIcon } from "ppt/utilities";
import { SEVERITY } from "ppt/constants";
import styles from "./ErrorCellRenderer.module.scss";

const ErrorCellRenderer = ({ value, data }) => {
  const hasErrors = value > 0;
  const maxSeverity = data?.maxSeverity || SEVERITY.OK;

  // Map severity to CSS color variables
  const severityColorClass =
    {
      [SEVERITY.ERROR]: styles.errorText,
      [SEVERITY.WARNING]: styles.warningText,
    }[maxSeverity] || styles.noError;

  const iconName = hasErrors ? getSeverityIcon(maxSeverity) : "";

  return (
    <div className={styles.container}>
      {hasErrors ? (
        <span className={severityColorClass}>
          <Icon
            altText={`${value} issue${value === 1 ? "" : "s"}`}
            faPackage="fal"
            iconName={iconName}
            iconType="fa"
            title={`${value} issue${value === 1 ? "" : "s"}`}
          />{" "}
          {value}
        </span>
      ) : (
        <span className={styles.noError}>-</span>
      )}
    </div>
  );
};

ErrorCellRenderer.propTypes = {
  value: PropTypes.number,
  data: PropTypes.object,
};

export default ErrorCellRenderer;
